import React, { useState, useEffect } from 'react';
import { Card, Upload, Button, Modal } from 'antd';
import { DeleteOutlined, PlusOutlined } from '@ant-design/icons';
import axios from 'axios';
import AdminNavbar from '../components/AdminNavbar';
import { useNavigate } from 'react-router-dom';


const AdminHomePage = () => {
  const [coverPhoto, setCoverPhoto] = useState(null);
  const [carouselImages, setCarouselImages] = useState([]);
  const [previewOpen, setPreviewOpen] = useState(false);
  const [previewImage, setPreviewImage] = useState('');
  const navigate = useNavigate();

  useEffect(() => {
    fetchCoverPhoto();
    fetchCarouselImages();
  }, []);

  function getCSRFToken() {
    return window.CSRF_TOKEN || '';
  }
  
  const fetchCoverPhoto = async () => {
    const token = localStorage.getItem('authToken');
    const csrfToken = getCSRFToken();
  
    const response = await axios.get('/api/homepage/cover', {
      headers: {
        Authorization: `Bearer ${token}`,
        'X-CSRFToken': csrfToken,
      },
      withCredentials: true,
    });
  
    if (response.data) {
      setCoverPhoto(response.data);
    }
  };
  
  const fetchCarouselImages = async () => {
    const token = localStorage.getItem('authToken');
    const csrfToken = getCSRFToken();
  
    const response = await axios.get('/api/homepage/carousel', {
      headers: {
        Authorization: `Bearer ${token}`,
        'X-CSRFToken': csrfToken,
      },
      withCredentials: true,
    });
  
    setCarouselImages(response.data);
  };
  
  const handleCoverUpload = async ({ file }) => {
    const token = localStorage.getItem('authToken');
    const csrfToken = getCSRFToken();
  
    const formData = new FormData();
    formData.append('cover_photo', file);
  
    await axios.post('/api/homepage/cover', formData, {
      headers: {
        Authorization: `Bearer ${token}`,
        'X-CSRFToken': csrfToken,
        'Content-Type': 'multipart/form-data',
      },
      withCredentials: true,
    });
  
    fetchCoverPhoto();
  };
  
  const handleCarouselUpload = async ({ file }) => {
    const token = localStorage.getItem('authToken');
    const csrfToken = getCSRFToken();
  
    const formData = new FormData();
    formData.append('image', file);
  
    await axios.post('/api/homepage/carousel', formData, {
      headers: {
        Authorization: `Bearer ${token}`,
        'X-CSRFToken': csrfToken,
        'Content-Type': 'multipart/form-data',
      },
      withCredentials: true,
    });
  
    fetchCarouselImages();
  };
  
  const handleRemoveCover = async () => {
    const token = localStorage.getItem('authToken');
    const csrfToken = getCSRFToken();
  
    await axios.delete('/api/homepage/cover', {
      headers: {
        Authorization: `Bearer ${token}`,
        'X-CSRFToken': csrfToken,
      },
      withCredentials: true,
    });
  
    setCoverPhoto(null);
  };
  
  const handleRemoveCarousel = async (id) => {
    const token = localStorage.getItem('authToken');
    const csrfToken = getCSRFToken();
  
    await axios.delete(`/api/homepage/carousel/${id}`, {
      headers: {
        Authorization: `Bearer ${token}`,
        'X-CSRFToken': csrfToken,
      },
      withCredentials: true,
    });
  
    fetchCarouselImages();
  };

  return (

    <>

    <AdminNavbar/>  

    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">

    <Button
    onClick={() => navigate('/admin-dashboard')}
    className="bg-gray-200 hover:bg-gray-300 text-gray-900 px-6 py-2 rounded-md text-sm mb-4"
    >
    Back to Dashboard
    </Button>

      <h2 className="text-2xl font-bold mb-6 text-blue-800">Website Home Page Management</h2>
      
      <Card title="Cover Photo" className="mb-8 shadow-md">
        {!coverPhoto ? (
          <Upload
            name="cover_photo"
            listType="picture-card"
            className="w-full"
            showUploadList={false}
            customRequest={handleCoverUpload}
          >
            <div className="text-center">
              <PlusOutlined className="text-2xl mb-2" />
              <div>Upload Cover Photo</div>
            </div>
          </Upload>
        ) : (
          <div className="relative">
            <img
              src={coverPhoto.cover_photo}
              alt="Cover"
              className="w-full h-full object-cover rounded-lg"
            />
            <Button
              type="primary"
              danger
              icon={<DeleteOutlined />}
              onClick={handleRemoveCover}
              className="absolute top-4 right-4"
            >
              Remove
            </Button>
          </div>
        )}
      </Card>

      <Card title="Carousel Images" className="shadow-md">
        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-4">
          {carouselImages.map((image) => (
            <div key={image.id} className="relative">
              <img
                src={image.image}
                alt={`Carousel ${image.id}`}
                className="w-full h-40 object-cover rounded-lg cursor-pointer"
                onClick={() => {
                  setPreviewImage(image.image);
                  setPreviewOpen(true);
                }}
              />
              <Button
                type="primary"
                danger
                icon={<DeleteOutlined />}
                onClick={() => handleRemoveCarousel(image.id)}
                className="absolute top-2 right-2"
                size="small"
              />
            </div>
          ))}
          
          {carouselImages.length < 12 && (
            <Upload
              name="image"
              listType="picture-card"
              showUploadList={false}
              customRequest={handleCarouselUpload}
            >
              <div className="text-center">
                <PlusOutlined className="text-2xl mb-2" />
                <div>Add Image</div>
                <div className="text-xs text-gray-500">
                  {12 - carouselImages.length} slots remaining
                </div>
              </div>
            </Upload>
          )}
        </div>
      </Card>

      <Modal
        open={previewOpen}
        footer={null}
        onCancel={() => setPreviewOpen(false)}
      >
        <img alt="Preview" className="w-full" src={previewImage} />
      </Modal>
    </div>

    </>
  );
};

export default AdminHomePage;